import { computed, observable } from "mobx";
import Customer from "./Customer";
import Provider from "./Provider";
import AppUserType from "~/constants/AppUser/AppUserType";

class User {
  /**
   * @property {number}
   */
  @observable appUserId = 0;

  /**
   * @property {string}
   */
  @observable username = "";

  /**
   * @property {number}
   */
  @observable userId = 0;

  /**
   * @property {string}
   */
  @observable name = "";

  /**
   * @property {string}
   */
  @observable type = "";

  /**
   * @property {string}
   */
  @observable password = "";

  /**
   * @property {boolean}
   */
  @observable hasRevertIdentity = false;

  /**
   * @property {boolean}
   */
  @observable enableClientYoutubeSetup = true;

  /**
   * @property {boolean}
   */
  @observable pocketWebsiteEnabled = false;

  @observable customer = null;

  @observable provider = null;

  constructor({
    appUserId = null,
    username = "",
    userId = null,
    name = "",
    type = "",
    password = "",
    hasRevertIdentity = false,
    enableClientYoutubeSetup = true,
    pocketWebsiteEnabled = false,
    customer = null,
    provider = null,
  }) {
    this.appUserId = appUserId;
    this.username = username;
    this.userId = userId;
    this.name = name;
    this.type = type;
    this.password = password;
    this.hasRevertIdentity = hasRevertIdentity;
    this.enableClientYoutubeSetup = enableClientYoutubeSetup;
    this.pocketWebsiteEnabled = pocketWebsiteEnabled;

    if (customer) {
      this.customer = new Customer(customer);
    }

    if (provider) {
      this.provider = new Provider(provider);
    }
  }

  @computed
  get isProvider() {
    return this.type === AppUserType.PROVIDER;
  }

  @computed
  get isCustomer() {
    return this.type === AppUserType.CUSTOMER;
  }

  @computed
  get actualUser() {
    if (this.type === AppUserType.PROVIDER) {
      return this.provider;
    }

    if (this.type === AppUserType.CUSTOMER) {
      return this.customer;
    }

    return null;
  }
}

export default User;
